import React from 'react'
import {
  AutocompleteArrayInput,
  AutocompleteArrayInputProps,
} from 'react-admin'
import { Organization } from 'services/api/entities/crm/organizations/types/internal/organization-model'
import { useKGetList } from 'services/hooks/useKGetList'
import KToolTip from 'ui-shared/KTooltip'

const OrganizationAutocompleteArrayInput: React.FC<
  AutocompleteArrayInputProps
> = (props) => {
  const organizations = useKGetList<Organization>('organization')

  return (
    <KToolTip
      title="form.fields.tailoredOrganizationTooltip"
      placement="top-start"
    >
      <AutocompleteArrayInput
        {...props}
        source="organizations"
        choices={organizations.map((e) => ({
          id: e.id,
          name: `${e.name} - ${e.responsibleFullName}`,
        }))}
      />
    </KToolTip>
  )
}

export default OrganizationAutocompleteArrayInput
